<script>
    import {createEventDispatcher} from "svelte";
    import Color from "./Color.svelte";
    import Slider from "./Slider.svelte";

    export let stroke;
    export let min = 1;
    export let max = 20;
    export let step = 0.5;
    export let label = 'Width'
    export let transparencyLabel = undefined;

    const dispatch = createEventDispatcher();

    let width = stroke.width;
    let color = stroke.color;

    function onChange() {
        dispatch('changeStyle', {stroke: {color, width}})
    }

    function onChangeColor(e) {
        color = e.detail;
        onChange();
    }
</script>

<label>
    <Slider bind:value={width} {min} {max} {step} on:change={onChange}>
        { label }
    </Slider>
</label>

<Color color={color} {transparencyLabel} on:changeColor={onChangeColor} />